import React from "react"
import { FlatMapSource, INTERACTABLE_MAP_FLAT_LAYER_IDS } from "./flat_source"
import { CampusFlowSource } from "./campus_flow"
import { FloorPlanSource } from "./floor_plan_source"
import { useAnalyticsContext } from "@ciq/shared/contexts/AnalyticsContext"
import { FeatureFlags } from "@ciq/shared/constants/featureFlags"
// import { ExtrudedMapSource, INTERACTABLE_MAP_EXTRUDED_LAYER_IDS } from "./extruded_source"

/**
 * Main map source component that delegates to 2D and 3D handlers
 */
export function MapSource({ map, isMapLoading }) {
  const { isFeatureEnabled } = useAnalyticsContext()
  const floorPlanEnabled = isFeatureEnabled(FeatureFlags.floor_plans)
  const zoneContrastEnabled = isFeatureEnabled(FeatureFlags.zone_contrast_outlines)

  return (
    <>
      <FlatMapSource map={map} isMapLoading={isMapLoading} />
      <CampusFlowSource map={map} isMapLoading={isMapLoading} />
      {floorPlanEnabled && (
        <FloorPlanSource
          map={map}
          isMapLoading={isMapLoading}
          zoneContrastEnabled={zoneContrastEnabled}
        />
      )}
      {/*<ExtrudedMapSource map={map} isMapLoading={isMapLoading} />*/}
    </>
  )
}

// Function to get all interactable layer IDs
export function getInteractableLayerIds() {
  return [...INTERACTABLE_MAP_FLAT_LAYER_IDS]
  // return [...INTERACTABLE_MAP_FLAT_LAYER_IDS, ...INTERACTABLE_MAP_EXTRUDED_LAYER_IDS]
}
